export type JumpCandidate = { page: number; rank: number }

export type QuotePlacement = 'placed' | 'guessed' | 'missing' | 'unread'

export type OnPagePlacement = Extract<QuotePlacement, 'placed' | 'guessed'>

export function jumpTarget(
  candidates: readonly JumpCandidate[],
  placement: (candidate: JumpCandidate) => QuotePlacement
): JumpCandidate | null {
  const ranked = [...candidates].sort((left, right) => left.rank - right.rank)
  const placedOrPending = ranked.find((candidate) => {
    const placed = placement(candidate)
    return placed === 'placed' || placed === 'unread'
  })
  return placedOrPending ?? ranked.find((candidate) => placement(candidate) === 'guessed') ?? null
}
